import React, { useState, useEffect } from "react";
import { PopupButton } from "react-calendly";
import "./BookBtn.css";

const BookBtn = () => {
  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = popupOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [popupOpen]);

  return (
    <PopupButton
      url="https://calendly.com/admin-softations/meet-softations-to-turn-your-idea-into-reality"
      rootElement={document.getElementById("root")}
      text="Book an Appointment"
      className="bookbtn"
      onClick={() => setPopupOpen(true)} 
      onModalClose={() => setPopupOpen(false)} 
    />
  );
};

export default BookBtn;
